import React, { useEffect } from 'react'

const toggleElementVisibility = displayStyle => {
  if (typeof window !== 'undefined') {
    const myClasses = window.document.querySelectorAll('.hide-on-booking')

    for (let i = 0; i < myClasses.length; i++) {
      myClasses[i].style.display = displayStyle
    }

    try {
      window.dispatchEvent(new window.Event('scroll'))
      window.dispatchEvent(new window.Event('resize'))
    } catch {
      // will break on IE11
    }
  }
}

const FullScreen = () => {
  useEffect(() => {
    toggleElementVisibility('none')

    return () => toggleElementVisibility('block')
  }, [])

  return <div />
}

export default FullScreen
